import { render, staticRenderFns } from "./StudentExaminationPoint.vue?vue&type=template&id=7db004c9&"
import script from "./StudentExaminationPoint.vue?vue&type=script&lang=js&"
export * from "./StudentExaminationPoint.vue?vue&type=script&lang=js&"
import style0 from "./StudentExaminationPoint.vue?vue&type=style&index=0&id=7db004c9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports